import { render, staticRenderFns } from "./SelectDocumentTypeField.vue?vue&type=template&id=361d2358"
import script from "./SelectDocumentTypeField.vue?vue&type=script&lang=js"
export * from "./SelectDocumentTypeField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports